import createStaticRef from '../../Core/Helpers/createStaticRef'

export default createStaticRef()
